/**
 * Apoio das telas do Clube de parceiros (cadastro do gestor, vitrine do cliente e validação do
 * parceiro). Fica num lugar só para o formato de links, código e arte ser o mesmo nas três.
 */

/** Endereço completo de uma imagem do parceiro, que a API devolve como caminho relativo. */
export const clubImageUrl = (path) => {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    return `${process.env.REACT_APP_API_URL}/${path.replace(/^\//, '')}`;
};

/** "donnabella.com.br" vira "https://donnabella.com.br": o gestor costuma digitar sem o protocolo. */
export const websiteUrl = (site) => {
    if (!site) return null;
    return /^https?:\/\//i.test(site) ? site : `https://${site}`;
};

/** Aceita "@perfil", "perfil" ou o link inteiro e devolve o link do perfil. */
const profileUrl = (value, base) => {
    if (!value) return null;
    if (/^https?:\/\//i.test(value)) return value;
    return `${base}/${value.replace(/^@/, '')}`;
};

export const instagramUrl = (value) => profileUrl(value, 'https://instagram.com');
export const facebookUrl = (value) => profileUrl(value, 'https://facebook.com');

/** Texto de exibição do perfil: "@donnabella" mesmo quando o gestor colou o link. */
export const profileHandle = (value) => {
    if (!value) return '';
    const clean = value.replace(/^https?:\/\/(www\.)?(instagram|facebook)\.com\//i, '').replace(/\/$/, '');
    return clean.startsWith('@') ? clean : `@${clean}`;
};

/** WhatsApp só com dígitos; sem DDI assume Brasil. */
export const whatsappUrl = (digits, message) => {
    if (!digits) return null;
    const number = digits.length <= 11 ? `55${digits}` : digits;
    return `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};

/** "K7M2QX" vira "K7M 2QX", mais fácil de ler e ditar no balcão. */
export const formatCouponCode = (code) => (code ? `${code.slice(0, 3)} ${code.slice(3)}` : '');

/** Texto curto do limite por cliente ("1 por mês"). */
export const usageLimitLabel = (offer) => {
    if (!offer?.usageLimit) return null;
    const times = offer.usageLimit === 1 ? '1 vez' : `${offer.usageLimit} vezes`;
    return offer.usageLimitPeriod === 'TOTAL' ? `${times} por cliente` : `${times} por mês`;
};

/** Aba de parceiros do agendamento de uma empresa, pelo apelido (slug) ou, na falta, o uuid. */
export const clubPublicUrl = (company) => {
    const identifier = company?.publicSlug || company?.uuid;
    return identifier ? `${window.location.origin}/booking/${identifier}/partners` : null;
};
